var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { call, put, takeLatest } from "redux-saga/effects";
import { CREATE_BULK_LABEL_REQUEST, createBulkLabelFailure, createBulkLabelSuccess } from "@/redux/actions";
import APIIN from "@/utils/APIIN";
const onSendBulkLabel = (action) => __awaiter(void 0, void 0, void 0, function* () {
    return yield new Promise((resolve, reject) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            APIIN.post(`cnvt/bulk/label?orderIds=${action.payload.orderIds}`, action.payload)
                .then((data) => {
                resolve(data);
            })
                .catch((error) => {
                reject(error);
            });
        }
        catch (error) {
            if (error instanceof Error) {
                reject(error);
            }
        }
    }));
});
function* sendBulkLabelWorker(action) {
    var _a, _b, _c, _d, _e, _f;
    try {
        const data = yield call(onSendBulkLabel, action);
        yield put(createBulkLabelSuccess(data));
    }
    catch (error) {
        if ((error === null || error === void 0 ? void 0 : error.response) && ((_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data) && ((_d = (_c = (_b = error === null || error === void 0 ? void 0 : error.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.message) === null || _d === void 0 ? void 0 : _d.length) > 0) {
            yield put(createBulkLabelFailure((_f = (_e = error === null || error === void 0 ? void 0 : error.response) === null || _e === void 0 ? void 0 : _e.data) === null || _f === void 0 ? void 0 : _f.message[0]));
        }
        else {
            yield put(createBulkLabelFailure(error));
        }
    }
}
export function* watchSendBulkLabelData() {
    yield takeLatest(CREATE_BULK_LABEL_REQUEST, sendBulkLabelWorker);
}
